/**
 * AdminPageHeader — unified header skeleton for admin tabs.
 *
 * Renders a consistent "title + description on the left, actions on the right"
 * layout. The action area reserves `min-h-[40px]` so tab content does not
 * shift when actions are conditional (e.g. Pending tab has an extra button).
 *
 * Use inside a `<Card className="shadow-lg border-0"><CardHeader>...` block,
 * or as a standalone header above a content area.
 */
export default function AdminPageHeader({ title, description, actions, className = "" }) {
  return (
    <div className={`flex flex-col sm:flex-row sm:justify-between sm:items-start gap-3 ${className}`}>
      <div className="min-w-0">
        <h2 className="font-display text-xl sm:text-2xl font-semibold text-brand-navy tracking-tight">
          {title}
        </h2>
        {description && (
          <p className="text-sm text-muted-foreground mt-1">{description}</p>
        )}
      </div>
      {/* Stable action area — reserves height so switching pages/tabs
          with/without actions never jolts the layout. */}
      <div className="flex flex-wrap items-center gap-2 min-h-[40px]">
        {actions}
      </div>
    </div>
  );
}
